import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1730cc5a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "recipients" };
var _hoisted_2 = { class: "recipients-header" };
var _hoisted_3 = { class: "recipients-header__info header-info" };
var _hoisted_4 = { class: "ml-2" };
var _hoisted_5 = { class: "header-info__text" };
var _hoisted_6 = { class: "header-info__name" };
var _hoisted_7 = {
    key: 0,
    class: "header-info__subtitle"
};
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "recipients-header__actions header-actions" }, null, -1); });
var _hoisted_9 = { class: "recipients-content" };
var _hoisted_10 = { class: "recipients-list" };
var _hoisted_11 = { class: "recipient-info" };
var _hoisted_12 = { class: "recipient-info__text" };
var _hoisted_13 = { class: "recipient-info__name" };
var _hoisted_14 = {
    key: 0,
    class: "opacity-0 transition-opacity duration-100 group-hover:opacity-100 hover-none:opacity-100"
};
import Auth from '@common/modules/auth';
import { AuthRoles } from '@common/interfaces/utils';
import CEmployeeAvatar from '@common/components/CEmployeeAvatar.vue';
import { computed } from 'vue';
import { ChatStore, CoreStore } from '@common/stores';
import Avatar from "@common/ui/EAvatar/EAvatar.vue";
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChatRecipients',
    setup: function (__props) {
        var t = useI18n().t;
        var coreStore = CoreStore;
        // onMounted(async () => {
        //     await sleep(0)
        // })
        var chat = computed(function () { return ChatStore.contentChat; });
        var chatLoading = computed(function () { return ChatStore.contentChatLoading; });
        var currentUser = computed(function () { return coreStore.user; });
        var goChat = function () {
            ChatStore.openChatPage();
        };
        var canOpenDialogue = function (user) {
            return user.id !== currentUser.value.id && !Auth.isStudentUser();
        };
        var openDialogue = function (user) {
            if (!canOpenDialogue(user)) {
                return;
            }
            ChatStore.openDialogue(user.id);
        };
        //Плюрализм
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            var _directive_loading = _resolveDirective("loading");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: "flex shrink-0 items-center py-2 font-medium text-gray-400 transition-colors cursor-pointer hover:text-primary-300",
                            onClick: goChat
                        }, [
                            _createVNode(_component_e_icon, {
                                class: "mr-1 w-2 h-4",
                                icon: "angle-left"
                            }),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('recipients.chat')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(chat.value.name), 1),
                            (chat.value.recipients)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " — " + _toDisplayString(_unref(t)('recipients.participant', chat.value.recipients.length)), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chat.value.recipients, function (user) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: user.id,
                                class: "block sm:flex sm:justify-between recipient group"
                            }, [
                                _createElementVNode("div", _hoisted_11, [
                                    (user.role === _unref(AuthRoles).ROLE_STUDENT)
                                        ? (_openBlock(), _createBlock(Avatar, {
                                            key: 0,
                                            "color-id": user.id,
                                            name: user.name ? user.name : user.email,
                                            src: user.avatar,
                                            class: "recipient-info__avatar"
                                        }, null, 8, ["color-id", "name", "src"]))
                                        : (_openBlock(), _createBlock(CEmployeeAvatar, {
                                            key: 1,
                                            name: user.name ? user.name : user.email,
                                            src: user.avatar,
                                            uuid: user.uuid,
                                            class: "!h-9 !w-9 mr-4",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(function () { }, ["stop"]))
                                        }, null, 8, ["name", "src", "uuid"])),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("p", _hoisted_13, _toDisplayString(user.name || user.email), 1)
                                    ])
                                ]),
                                (!_unref(Auth).isStudentUser() && currentUser.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        (user.id !== currentUser.value.id)
                                            ? (_openBlock(), _createBlock(_component_e_button, {
                                                key: 0,
                                                disabled: !canOpenDialogue(user),
                                                class: "mt-3 sm:mt-0",
                                                type: "primary-alt",
                                                onClick: function ($event) { return (openDialogue(user)); }
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createTextVNode(_toDisplayString(_unref(t)('recipients.sendMessage')), 1)
                                                ]; }),
                                                _: 2
                                            }, 1032, ["disabled", "onClick"]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ])
                ])
            ])), [
                [_directive_loading, chatLoading.value]
            ]);
        };
    }
});
